import React from 'react'
import classNames from 'classnames'
import './style/button.css'
import {ButtonProps} from "./util/ButtonProps";

const Button = (props: ButtonProps) => {
  const {
    label,
    onClick,
    disabled = false,
    className,
    ...rest
  } = props

  const internalOnClick = (): void => {
    if (!disabled) {
      onClick()
    }
  }

  return (
    <button type="button"
         className={classNames("button", className, {"disabled-button": disabled})}
         onClick={internalOnClick}
         {...rest}>
      {label}
    </button>
  )
}

export default Button

